import React from "react";
import "./ZikRmeProPlan.css";
import { Link } from "react-router-dom";
const ZikRmeProPlan = () => {
  return (
    <div className="pro-main">
      <div className="pro-content">
        <h1>ZikRme Pro Travel Plan</h1>

        <p>Not Ready to Book? No Problem; Use ZikRme Pro Travel Plans</p>

        <div className="btn-group">
       <Link to="/what-you-get"><button className="pro-btn">What you Get</button></Link>  
      <Link to="/travel-panning"><button className="pro-btn">Build your Own Trip</button></Link>
        </div>
      </div>
    </div>
  );
};

export default ZikRmeProPlan;
